module.exports = __webpack_public_path__ + "static/bike-camp-4aec819f93265603842df2128a11147f.jpg";